import { useGetCustomer } from './useGetCustomer'

export function useUsername() {
  return useGetCustomer().data?.username || ''
}
